import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';

export const moduleTitle = "CREATE REQUEST";
export const tablePageSize = GLOBAL_TABLE_PAGE_SIZE;

export default tablePageSize;